/* eslint-disable @typescript-eslint/no-empty-interface */
import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import { Page404 } from '../components/page-404';

export interface Props {}

@inject(deps)
@observer
export class _404Page extends Component<Props> {
  render() {
    return <Page404 />;
  }
}
